/**
 * Service de cache pour optimiser les requêtes à la base de données
 */

class CacheService {
  constructor() {
    this.cache = new Map()
    this.cacheExpiry = new Map()
    // Durée de cache par défaut : 5 minutes
    this.defaultTTL = 5 * 60 * 1000
  }

  /**
   * Obtenir une valeur du cache
   */
  get(key) {
    const now = Date.now()
    const expiry = this.cacheExpiry.get(key)

    // Vérifier si le cache a expiré
    if (expiry && now > expiry) {
      this.delete(key)
      return null
    }

    return this.cache.get(key)
  }

  /**
   * Définir une valeur dans le cache
   */
  set(key, value, ttl = this.defaultTTL) {
    const expiry = Date.now() + ttl
    this.cache.set(key, value)
    this.cacheExpiry.set(key, expiry)
  }

  /**
   * Supprimer une valeur du cache
   */
  delete(key) {
    this.cache.delete(key)
    this.cacheExpiry.delete(key)
  }

  /**
   * Vider tout le cache
   */
  clear() {
    this.cache.clear()
    this.cacheExpiry.clear()
  }

  /**
   * Vérifier si une clé existe dans le cache et est valide
   */
  has(key) {
    return this.get(key) !== null
  }
}

// Instance singleton
export const cacheService = new CacheService()
